import { HttpContextToken } from '@angular/common/http';

// Requête du module Planning v2 : le 401 est rendu à la fonctionnalité si handles401 (commandes en attente).
export interface PlanningRequestContext { handles401: boolean }
export const PLANNING_REQUEST = new HttpContextToken<PlanningRequestContext | null>(() => null);
